import queryString from 'qs';

const getHostStockListRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.search) queries.search = queryParams?.search;
  if (queryParams?.brandId) queries.brand = `[${queryParams?.brandId?.join(',')}]`;
  if (queryParams?.stockStatus) queries.statusStock = queryParams?.stockStatus;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getHostStockListRequest;
